import { createSlice } from "@reduxjs/toolkit";

const initialHomework = {
  lastDate: "",
  definition: ""
};

const initialHomeworksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  homework: initialHomework
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const teacherHomeworkSlice = createSlice({
  name: "teacherHomeworks",
  initialState: initialHomeworksState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    startAnswersCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.answersListLoading = true;
      } else {
        state.answersActionsLoading = true;
      }
    },
    // getHomeworks
    homeworksFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getHomeworkAnswers
    answersFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.answersListLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.answers = entities;
      state.answerTotalCount = totalCount;
      state.authorities = authorities;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
      state.homeworkEvaluations = [];
      
      entities.forEach(entity => {
        state.homeworkEvaluations.push({
          id: entity.id,
          homeworkStatus: entity.homeworkStatus,
          explanation: entity.evaluationExplanation
        });
      });
    },
    // getList
    listFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entity.sections;
      state.courses = entity.courses;
    },
    // getStudentsInCourses
    studentsInCoursesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.students = entities;
    },
    // getSources
    sourcesFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sources = entities;
    },
    // getHomework
    homeworkFetched: (state, action) => {
      const { isSuccess, type, entity } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;      
      state.homework = entity;
      state.courses = entity && entity.courses;
      state.sources = entity && entity.sources;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // completeAnswersAction
    answersActionCompleted: (state) => {
      state.answersActionsLoading = false;
    },
    // cleanAttachment
    attachmentCleaned: (state) => {
      state.homework.attachmentName = null;
    },
    // cleanHomeworkState
    homeworkStateCleaned: (state) => {
      state.homework = initialHomework;
    },
    // cleanAnswersState
    answersStateCleaned: (state) => {
      state.answerTotalCount = 0;
      state.answers = undefined;
    },
    // cleanHomeworksState
    homeworksStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.students = undefined;
      state.entities = undefined;
    }
  }
});